import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: theme.spacing(4)
  },
  rightBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginLeft: '30px'
  },
  leftBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: '30px'
  },
  tags: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderRadius: '6px',
    backgroundColor: '#FFFFFF'
  },
  tag: {
    display: 'flex',
    flexDirection: 'column',
    width: '29%',
    padding: theme.spacing(1.5, 2),
    color: '#8688A1'
  },
  mostTag: {
    display: 'flex',
    flexDirection: 'column',
    width: '29%',
    borderRadius: '6px',
    backgroundColor: '#F7901E',
    color: '#FFFFFF',
    padding: theme.spacing(1.5, 2)
  },
  amount: {
    textAlign: 'center'
  },
  icon: {
    textAlign: 'center',
    margin: '4px 0'
  },
  name: {
    textAlign: 'center',
    textTransform: 'uppercase',
    minHeight: '26px'
  }
}))
